<div class="body">

    <div class="shortcuts">

        <ng-container *ngFor="let option of (service.options$|async)">

            <div *ngIf="option.visible()" @fade class="option" [class]="option.appearance()"
                (click)="optionClicked(option)">

                <ng-container *ngIf="option.tooltip; else noTooltip">
                    <mat-icon class="icon" [matTooltip]="option.tooltip">{{option.icon()}}</mat-icon>
                </ng-container>

                <ng-template #noTooltip>
                    <mat-icon class="icon">{{option.icon()}}</mat-icon>
                </ng-template>

                <span class="title">{{option.title()}}</span>

            </div>

        </ng-container>

    </div>

    <ng-container *ngIf="(service.oneTimeOptions$|async).length > 0">

        <div @show class="expandable-menu">

            <div class="expandable-menu-control-bar">
                <button mat-icon-button color="warn" (click)="service.clearOneTimeOptions()" [disabled]="service.preventOneTimeClose$|async">
                    <mat-icon>clear</mat-icon>
                </button>
            </div>

            <ng-container *ngFor="let option of (service.oneTimeOptions$|async)">

                <div class="one-time-option" (click)="oneTimeOptionClicked(option)">
                    {{option.title()}}
                </div>

            </ng-container>

        </div>

    </ng-container>

</div>

